import React from 'react';
import {observer} from 'mobx-react-lite';
import {
    CheckIconWrapper,
    ColorOptionWrapper,
    ColorOption,
    SectionLabel,
    ColorSelectOption,
    ColorPickerWrapper,
    ColorPaletteWrapper
} from 'src/main/cms/Sports/SportsForm/ColorPicker/ColorPicker.style';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { withConfig } from 'src/utils/withConfig';
import { useAppStateContext } from 'src/AppState/AppState';

export interface CheckboxPropsType {
    setColor: (value: string) => void,
    label: string
    color: FormInputState<string, string>
}

export const ColorPicker = withConfig(theme => observer((props: CheckboxPropsType): JSX.Element => {
    const { setColor, label, color } = props;
    const { configState } = useAppStateContext();

    const operatorName = configState.config.operatorFullName;
    const availableColors = Object.values(theme.colorPicker.colors);

    return (
        <ColorPickerWrapper>
            <SectionLabel>{label} color</SectionLabel>
            <ColorSelectOption>Select from {operatorName} color palette:</ColorSelectOption>
            <ColorPaletteWrapper>
                {availableColors.map((color) => (
                    <ColorOptionWrapper key={color}>
                        <ColorOption color={color} onClick={(): void => setColor(color)} isChecked={color === color.value}>
                            { color === color.value ? <CheckIconWrapper isChecked={color === color.value} /> : null }
                        </ColorOption>
                    </ColorOptionWrapper>
                ))}
            </ColorPaletteWrapper>
            <ColorSelectOption>or use another color (#hex value only):</ColorSelectOption>
            <Input formInputState={color} dataTest={`custom-${label.toLowerCase()}-color`}/>
        </ColorPickerWrapper>
    );
}));
